import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLeaf16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconLeaf16"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Leaf16)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="m6 9.3-1.212 1.213A4.417 4.417 0 0 1 5.12 4.64c.38-.38 1.027-.749 1.886-1.061.843-.307 1.811-.532 2.758-.67.947-.14 1.84-.187 2.524-.155a4.5 4.5 0 0 1 .853.111l.016.06c.043.183.079.448.095.793.033.685-.015 1.577-.154 2.524s-.364 1.915-.67 2.758c-.313.859-.681 1.506-1.062 1.886a4.417 4.417 0 0 1-5.872.334l1.212-1.212h2.98a.5.5 0 1 0 0-1h-1.98l2.437-2.437a.5.5 0 1 0-.707-.707L7 8.3V6.64a.5.5 0 0 0-1 0zM4.414 3.933a5.417 5.417 0 0 0-.337 7.29l-1.36 1.36a.5.5 0 1 0 .707.707l1.36-1.36a5.417 5.417 0 0 0 7.29-.337c2.116-2.115 2.654-8.612 1.803-9.463S6.53 1.817 4.414 3.933"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Leaf16">
                        <path fill="#fff" d="M0 0h16v16H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconLeaf16);
